export default __webpack_public_path__ + "static/media/contact-us.baa57e32.webp";